import React, { useEffect,useState } from 'react'
import Loader from './Loader'
import '../assets/css/style.css'
import '../assets/animate/animate.css'
import axios from 'axios'
import BASE_URL from '../context/AppConfig'

function Contact() {
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({ name: "",phone:"", email: "", subject:"", message: "" });
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    console.log(formData);

    try {
      const res = await axios.post(`${BASE_URL}/submit-query/`, formData);
      if (res.data.message) {
        setSuccessMessage(res.data.message);

        setFormData({ name: "", phone:"", email: "",subject:"", message: "" });
      }
    } catch (err) {
      setError("Failed to submit. Please try again.");
    }
  };

  useEffect(() => {
    const fetchOfficeDetails = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/offices/`);
        setOffices(response.data);
        
        

      } catch (error) {
        console.error("Failed to fetch office details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOfficeDetails();
  }, []);

  
  
  return (
    <div class="contact wow fadeInUp">
                <div class="container">
                    <div class="section-header text-center">
                        <p>Get In Touch</p>
                        <h2>For Any Query</h2>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="contact-info">
                                <div class="contact-item">
                                    <i class="flaticon-address"></i>
                                    <div class="contact-text">
                                        <h2>Location</h2>
                                        <p>{offices[0]?.address} Noida, Uttar pradesh, India</p>
                                    </div>
                                </div>
                                <div class="contact-item">
                                    <i class="flaticon-call"></i>
                                    <div class="contact-text">
                                        <h2>Phone</h2>
                                        <p>{offices[0]?.phone} 9818591361</p>
                                    </div>
                                </div>
                                <div class="contact-item">
                                    <i class="flaticon-send-mail"></i>
                                    <div class="contact-text">
                                        <h2>Email</h2>
                                        <p>{offices[0]?.email} info@saaraconstructions.com</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="contact-form">
                                <div id="success"></div>
                                <form name="sentMessage" id="contactForm" novalidate="novalidate" onSubmit={handleSubmit}>
                                    <div class="control-group">
                                        <input type="text" class="form-control" id="name" placeholder="Your Name" required="required" name = "name" data-validation-required-message="Please enter your name" value={formData.name} onChange={handleChange} />
                                        <p class="help-block text-danger"></p>
                                    </div>
                                    <div class="control-group">
                                        <input type="text" class="form-control" id="phone" placeholder="Your Phone No" required="required" data-validation-required-message="Please enter your phone" name='phone' value={formData.phone} onChange={handleChange} />
                                        <p class="help-block text-danger"></p>
                                    </div>
                                    <div class="control-group">
                                        <input type="email" class="form-control" id="email" placeholder="Your Email" required="required" data-validation-required-message="Please enter your email" name='email' value={formData.email} onChange={handleChange}/>
                                        <p class="help-block text-danger"></p>
                                    </div>
                                    
                                    <div class="control-group">
                                        <input type="text" class="form-control" id="subject" placeholder="Subject" required="required" data-validation-required-message="Please enter a subject" name='subject' value={formData.subject} onChange={handleChange} />
                                        <p class="help-block text-danger"></p>
                                    </div>
                                    <div class="control-group">
                                        <textarea class="form-control" id="message" placeholder="Message" required="required" data-validation-required-message="Please enter your message" name='message' value={formData.message} onChange={handleChange}></textarea>
                                        <p class="help-block text-danger"></p>
                                    </div>
                                    <div>
                                        <button class="btn" type="submit" id="sendMessageButton" >Send Message</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
  )
}

export default Contact
